import React from 'react';

import LOGO from '@iso/assets/images/wahjef-logo.png';

import { Wrapper } from './LogoLoader.styles';

const LogoLoader = () => (
  <Wrapper>
    <div className="sbl-circ-dual" />
    <img src={LOGO} className="logo" />
  </Wrapper>
);

export default LogoLoader;
